import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericDD } from 'src/app/model/generic-data';
import { MDAdd, genericMD, mdLenght, mdResponse } from 'src/app/model/masterdata/masterdata';
import { BaseResponse } from 'src/app/model/response/base-response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OcrService {

  private url: string = `http://127.0.0.1:5000/ocr`;
  private baseUrl: string = `${environment.apiUrl}/sla`;

  private tables: Array<string> = ['tipologia-cliente', 'unita-misura','categoria-fornitore','categorie','settori','settori-cliente','sedi', 'sla','tipologia-attivita','priorita', 'area-ticket'];
  //tabelle femminili per mettere l'articolo femminile nei messaggi tradotti in italiano
  private femTables: Array<string> = ['tipologia-cliente','unita-misura','categoria-fornitore','categorie','sedi', 'sla','tipologia-attivita','priorita', 'area-ticket'];
  //tabelle che iniziano con una vocale e quindi necessitano dell'apostrofo
  private specialTables: Array<string> = ['unita-misura'];

  constructor(private http: HttpClient) { }

  OCR(image:string):Observable<{text:string[]}>{
    return this.http.post<{text:string[]}>(`${this.url}`,{image: image});
  }



}
